import { createContext, useContext } from 'react';
import { createTranslator, type Locale, type TranslateValues } from '@jt/shared/i18n';

export interface I18nValue {
  locale: Locale;
  dir: 'rtl' | 'ltr';
  t: (key: string, values?: TranslateValues) => string;
  has: (key: string) => boolean;
  setLocale: (locale: Locale) => void;
}

const fallback = createTranslator('fa');

export const I18nContext = createContext<I18nValue>({
  locale: 'fa',
  dir: 'rtl',
  t: fallback.t,
  has: fallback.has,
  setLocale: () => undefined,
});

export function useI18n(): I18nValue {
  return useContext(I18nContext);
}

export { createTranslator };
export type { Locale };
